import {
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { FaCheck, FaEye, FaEyeSlash, FaTimes } from "react-icons/fa";
import ReactInputMask from "react-input-mask";

import { AuthContext } from "../../../../contexts/auth";
import RoleService from "../../../../services/roles.service";
import { LabeledInput } from "../../../UI/LabeledInput";

export const PASSWORD_RULES = [
  { label: "Pelo menos 8 caracteres", test: (p: string) => p.length >= 8 },
  {
    label: "Pelo menos uma letra maiúscula",
    test: (p: string) => /[A-Z]/.test(p),
  },
  {
    label: "Pelo menos um caractere especial (@!%$#.)",
    test: (p: string) => /[@!%$#.]/.test(p),
  },
  { label: "Pelo menos um número", test: (p: string) => /[0-9]/.test(p) },
];

type Props = {
  data: any;
  onChange: (event: any) => void;
  rolesArr: any[];
  isEditing: boolean;
};

export const RegisterStep: React.FC<Props> = ({
  onChange,
  data,
  rolesArr,
  isEditing,
}) => {
  const { user } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const passwordRulesMet = PASSWORD_RULES.map((rule) =>
    rule.test(data.password || ""),
  );
  const passwordsMatch =
    (data.password || "") === (data.password_confirmation || "");
  const confirmFilled = (data.password_confirmation || "").length > 0;

  function typesRender() {
    return rolesArr.map((el: any) => {
      return <MenuItem value={el._id}>{el.name}</MenuItem>;
    });
  }

  return (
    <Box
      component="form"
      sx={{ "& .MuiTextField-root": { m: 1 } }}
      autoComplete="off"
      width={"100%"}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"flex-start"}
    >
      <span style={{ fontSize: 16, fontWeight: 600 }}>Informações</span>
      <Box display={"flex"} width={"100%"} mt={1}>
        <LabeledInput
          fullWidth
          size="small"
          label="Nome Completo"
          name="name"
          value={data.name}
          onChange={onChange}
          placeholder="Nome Completo"
        />
      </Box>
      {/* <Box display={"flex"} width={"100%"}>
        <LabeledInput
          fullWidth
          size="small"
          label="Login"
          value={data.user_name}
          onChange={(e) => {
            e.target.name = "user_name";
            onChange(e);
          }}
          placeholder="nome.sobrenome"
        />
      </Box> */}

      <Box display={"flex"} width={"100%"} gap={2} mb={2}>
        <ReactInputMask
          // @ts-ignore
          maskPlaceholder={null}
          mask="(99) 99999-9999"
          value={data.phone}
          onChange={onChange}
          name="phone"
        >
          <LabeledInput
            fullWidth
            size="small"
            label="Celular"
            name="phone"
            value={data.phone}
            onChange={onChange}
            placeholder="(00) 0 0000 0000"
          />
        </ReactInputMask>
        <LabeledInput
          fullWidth
          size="small"
          label="Email"
          onChange={(e) => {
            e.target.name = "email";
            onChange(e);
          }}
          value={data.email}
          placeholder="nome.sobrenome@grupommeventos.com"
        />
      </Box>

      {/* <Box display={"flex"} width={"100%"}>
        <ReactInputMask
          // @ts-ignore
          maskPlaceholder={null}
          mask="(99) 99999-9999"
          value={data.phone}
          onChange={onChange}
          name="phone"
        >
          <LabeledInput
            fullWidth
            size="small"
            label="Celular"
            name="phone"
            value={data.phone}
            onChange={onChange}
            placeholder="(00) 0 0000 0000"
          />
        </ReactInputMask>
      </Box> */}

      <span style={{ fontSize: 16, fontWeight: 600 }}>Função e acesso</span>

      <Box display={"flex"} width={"100%"} mt={1}>
        <LabeledInput
          fullWidth
          size="small"
          label="Login"
          value={data.user_name}
          onChange={(e) => {
            e.target.name = "user_name";
            onChange(e);
          }}
          placeholder="Login para o usuário"
        />
      </Box>

      <Box
        display={"flex"}
        justifyContent={"space-between"}
        width={"100%"}
        mt={1}
      >
        <FormControl style={{ width: "100%" }} size="small">
          <InputLabel size="small" id="demo-simple-select-label">
            Função
          </InputLabel>
          <Select
            value={data.function_id}
            onChange={onChange}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Função"
            size="small"
            name="function_id"
            MenuProps={{
              style: {
                maxHeight: 450,
              },
            }}
          >
            {typesRender()}
          </Select>
        </FormControl>
      </Box>
      {/* <Box
        display={"flex"}
        justifyContent={"flex-start"}
        width={"100%"}
        my={1}
        ml={1}
      /> */}
      <Box width={"100%"}>
        <LabeledInput
          fullWidth
          size="small"
          label="Senha"
          value={data.password}
          onChange={(e) => {
            e.target.name = "password";
            onChange(e);
          }}
          placeholder="Crie uma senha"
          type={showPassword ? "text" : "password"}
          InputProps={{
            endAdornment: showPassword ? (
              <FaEyeSlash
                style={{ cursor: "pointer" }}
                onClick={() => setShowPassword(false)}
              />
            ) : (
              <FaEye
                style={{ cursor: "pointer" }}
                onClick={() => setShowPassword(true)}
              />
            ),
          }}
        />

        {(data.password || "").length > 0 && (
          <Box
            ml={1}
            mb={1}
            p={1.5}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 1,
              backgroundColor: "#fafafa",
            }}
          >
            {PASSWORD_RULES.map((rule, i) => (
              <Box
                key={i}
                display="flex"
                alignItems="center"
                gap={1}
                mb={0.5}
              >
                {passwordRulesMet[i] ? (
                  <FaCheck color="#4caf50" size={12} />
                ) : (
                  <FaTimes color="#f44336" size={12} />
                )}
                <Typography
                  variant="caption"
                  color={passwordRulesMet[i] ? "#4caf50" : "#f44336"}
                >
                  {rule.label}
                </Typography>
              </Box>
            ))}
            {confirmFilled && (
              <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                {passwordsMatch ? (
                  <FaCheck color="#4caf50" size={12} />
                ) : (
                  <FaTimes color="#f44336" size={12} />
                )}
                <Typography
                  variant="caption"
                  color={passwordsMatch ? "#4caf50" : "#f44336"}
                >
                  As senhas precisam ser iguais
                </Typography>
              </Box>
            )}
          </Box>
        )}

        <LabeledInput
          fullWidth
          size="small"
          label="Confirmar senha"
          value={data.password_confirmation}
          onChange={(e) => {
            e.target.name = "password_confirmation";
            onChange(e);
          }}
          placeholder="Confirme a senha"
          type={showConfirm ? "text" : "password"}
          InputProps={{
            endAdornment: showConfirm ? (
              <FaEyeSlash
                style={{ cursor: "pointer" }}
                onClick={() => setShowConfirm(false)}
              />
            ) : (
              <FaEye
                style={{ cursor: "pointer" }}
                onClick={() => setShowConfirm(true)}
              />
            ),
          }}
        />
      </Box>
    </Box>
  );
};
